import { z } from "zod";

const searchResultObject = z.object({
  title: z.string(),
  url: z.string(),
  date: z.string().nullable(),
  last_updated: z.string().nullable(),
  icon: z.string().nullable(),
});

const imageObject = z.object({
  image_url: z.string(),
  origin_url: z.string(),
  height: z.number(),
  width: z.number(),
});

const aiResultObject = z.object({
  content: z.string(),
  search_results: z.array(searchResultObject).optional().catch([]),
  id: z.string(),
  query: z.string(),
  conversation_id: z.string(),
  images: z.array(imageObject).catch([]),
  error: z.string().optional().catch(undefined),
});

type AiResult = z.infer<typeof aiResultObject>;

export { aiResultObject, type AiResult };
